import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { registerLicense } from "@syncfusion/ej2-base";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "flatpickr/dist/flatpickr.css";
import "./i18n/config";
import App from "./App.tsx";
import { AppWrapper } from "@components/common/PageMeta.tsx";
import { ThemeProvider } from "./context/ThemeContext.tsx";
import { AntdThemeWrapper } from "./context/AntdThemeWrapper.tsx";
import { store, persistor } from "./store";

const syncfusionLicense = import.meta.env.VITE_SYNCFUSION_LICENSE?.trim();
if (syncfusionLicense) {
  registerLicense(syncfusionLicense);
}

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider>
        <AntdThemeWrapper>
          <AppWrapper>
            <App />
            <ToastContainer
              style={{ zIndex: 999999 }}
              position="top-right"
              autoClose={3500}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              pauseOnHover
              draggable
              theme="light"
            />
          </AppWrapper>
        </AntdThemeWrapper>
      </ThemeProvider>
    </PersistGate>
  </Provider>,
);
